module.exports = __webpack_public_path__ + "static/img/博信诚（北京）网络科技有限公司牌匾40-60.6793fc72.jpg";